<template lang='pug'>
  v-flex(:class="classObj", :title='component.label')
    v-data-table(:headers='headers', :items='items', :expand='expand', hide-actions)
      template(slot="headerCell" slot-scope="props")
        span(v-if='props.header.checkAll !== undefined')
          | {{props.header.text}}
          v-radio-group.u-radio(
            v-model="headerColumnCheck"
            :label="component.label"
            hide-detail
            @mousedown="onHeaderColumnClick(props.header.value)")
            v-radio(
              :name="id"
              :value="props.header.value"
              :color="props.header.color")
        div(v-else width="100%") {{ props.header.text }}
      template(v-slot:items='props')
        td {{ t(`${id}.${props.item.key}`, props.item.label) }}
        td(v-for="(item, index) in props.item.radios", :key="item.key")
          u-radio.u-radio(v-model="item.value", :name="item.name", :component="{items: [item.component]}" @update="updateData({...$event, props})")
        td
          v-text-field(
            v-if="isNumeric"
            v-model="resultForm[props.item.radios[0].name+'.obs']"
            hide-details=''
            single-line=''
            suffix='mm'
            type='number')
          u-select(
            v-else
            :id="props.item.label"
            v-model="resultForm[props.item.radios[0].name+'.obs']"
            @change="updateData({key: props.item.radios[0].name+'.obs', value: $event})"
            :component="{key: props.item.radios[0].name+'.obs', items: [], style: 'xs12', editable: true, noChips: true, hiddenInfo: true}")
        td
          u-select(
            v-show="listAlter[props.item.radios[0].name]"
            :id="props.item.label+'.alterDesc'"
            v-model="resultForm[props.item.radios[0].name+'.alterDesc']"
            @change="updateData({key: props.item.radios[0].name+'.alterDesc', value: $event})"
            :component="{key: props.item.radios[0].name+'.alterDesc', items: [], style: 'xs12', editable: true, noChips: true, hiddenInfo: true}")
      template(v-slot:expand='props')
        v-card
          v-card-text
            u-form(v-if="form.rows && form.rows[props.index].components && form.rows[props.index].components.length > 0" v-model="resultForm" :formKey="props.item.id" flex :id="form.key" :json="form.rows[props.index].components[0] || {}")

</template>

<script>
import _ from 'lodash'
import { EventBus } from '@/event-bus'
import URadio from './Radio'
import USelect from './Select'
import SelectImage from '../inputs/SelectImage'
import FieldInfo from '@/components/form/buttons/FieldImage'

export default {
  name: 'u-table',

  components: {
    USelect,
    URadio,
    FieldInfo,
    SelectImage
  },

  props: {
    id: {
      type: String
    },
    component: {
      type: Object,
      required: true
    },
    resultForm: {
      type: Object
    },
    value: {}
  },
  computed: {
    form () {
      return this.component
    },
    headers () {
      let headers = [
        {
          text: '',
          align: 'left',
          sortable: false,
          value: 'name'
        }
      ]

      this.component.columns.forEach(item => {
        headers.push({
          text: item.label,
          align: 'center',
          sortable: false,
          value: item.value,
          color: item.color,
          checkAll: false
        })
      })
      headers.push({
        text: (this.component.lastColumn) ? this.component.lastColumn : 'Observações',
        align: 'left',
        sortable: false,
        value: ''
      })
      if (this.component.alterDesc) {
        headers.push({
          text: 'Descrição',
          align: 'left',
          sortable: false,
          value: ''
        })
      }

      return headers
    },
    items () {
      let indexKey = 1
      let items = []
      const data = this.dataComponent
      this.component.rows.forEach(row => {
        const id = `${this.id}.${row.key}`
        const val = data[id]
        let item = {
          id,
          label: row.label,
          value: val,
          radios: []
        }

        this.component.columns.forEach(col => {
          item.radios.push({
            value: val === col.value ? val : null,
            component: col,
            name: id,
            key: this.id + indexKey
          })
          indexKey++
        })

        items.push(item)
      })

      return items
    }
  },

  watch: {
    value (val) {
      this.dataComponent = Object.assign({}, val)
      // this.$recompute('items')
    },
    resultForm (val) {
      const filtered = Object.entries(val).filter(([key, value]) => key.indexOf(this.id) > -1)
      // console.log(this.id, filtered, this.dataComponent)
      const data = filtered.reduce(function (acc, cur, i) {
        acc[cur[0]] = cur[1]
        return acc
      }, {})
      this.dataComponent = Object.assign(data, {})
      // this.$recompute('items')
    },
    dataComponent (val) {
      this.$emit('update:resultForm', Object.assign(this.resultForm, val))
    }
  },

  data () {
    return {
      dataComponent: {},
      headerColumnCheck: null,
      isNumeric: (this.component.numeric && this.component.numeric === 'true'),
      listAlter: [],
      expand: true
    }
  },

  methods: {
    updateListAlter (payload) {
      if (payload.value === 'alterado') this.listAlter[payload.key] += payload.value
      else delete this.listAlter[payload.key]
    },
    updateData (payload) {
      // verifica se o valor é alterado e expande a linha(esse caso funciona pois o alterado é a segunda coluna do radio)
      payload.props.expanded = payload.props.item.radios[1].value === 'alterado'
      // se o valor for nulo, não faz nada
      if (!payload.value) return
      // se o componente tem descrição, atualiza a lista de alterações
      if (this.component.alterDesc) this.updateListAlter(payload)
      // emite o evento de atualização do resultado
      EventBus.$emit('eventField', { event: 'updateResultForm', val: { field: payload.key, value: payload.value } })
    },
    onHeaderColumnClick (val) {
      if (this.headerColumnCheck === val) {
        setTimeout(() => {
          this.headerColumnCheck = null
        }, 500)
        const items = _.cloneDeep(this.items)
        let payload = []
        items.forEach(item => {
          const radioComp = item.radios.filter(itemComp => itemComp.component.value === val)[0]
          payload.push({ field: radioComp.name, value: null })
        })
        console.log('payload', payload)
        EventBus.$emit('eventField', { event: 'updateResultForm', val: payload })
      } else {
        this.headerColumnCheck = val
        const items = _.cloneDeep(this.items)
        let payload = []
        items.forEach(item => {
          const radioComp = item.radios.filter(itemComp => itemComp.component.value === val)[0]
          payload.push({ field: radioComp.name, value: val })
        })
        console.log('payload', payload)
        EventBus.$emit('eventField', { event: 'updateResultForm', val: payload })
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
  .u-radio >>> .v-input__control
    width 100%
  .u-radio >>> .v-input__slot, .u-radio >>> .v-input--selection-controls__input
    margin 0
  .u-radio >>> .v-messages
    display none
  .u-radio >>> .v-radio
    justify-content center
    margin 0
</style>



// WEBPACK FOOTER //
// src/components/form/inputs/Table.vue